module.exports = __webpack_public_path__ + "static/media/yonna.d6269954.png";